var size = {
    mobileS: '320px',
    mobileL: '414px',
    tablet: '768px',
    laptop: '1024px',
};
export default size;
